import { nextBirthdayIso } from './birthdayDayOff';
import { isWeekendIsoDate } from './dayOffRules';

export const BIRTHDAY_REMINDER_DAYS_AHEAD = 15;

export function addDaysIso(isoDate: string, days: number): string {
    const [year, month, day] = isoDate.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day + days)).toISOString().slice(0, 10);
}

export function birthdayReminderTarget(birthDate: unknown, todayIso: string): string | null {
    const target = addDaysIso(todayIso, BIRTHDAY_REMINDER_DAYS_AHEAD);
    return nextBirthdayIso(birthDate, todayIso) === target ? target : null;
}

export type BirthdayDayOffIssue = 'weekend' | 'holiday' | 'vacation';

export const BIRTHDAY_ISSUE_LABELS: Record<BirthdayDayOffIssue, string> = {
    weekend: 'fim de semana',
    holiday: 'feriado',
    vacation: 'período de férias',
};

export function birthdayDayOffIssue(
    targetIso: string,
    holidays: readonly string[],
    vacationRanges: ReadonlyArray<{ startDate: string; endDate: string }>
): BirthdayDayOffIssue | null {
    if (isWeekendIsoDate(targetIso)) return 'weekend';
    if (holidays.includes(targetIso)) return 'holiday';
    if (vacationRanges.some(range => targetIso >= range.startDate && targetIso <= range.endDate)) return 'vacation';
    return null;
}

export function isBirthdayDayOffEligibleDate(
    targetIso: string,
    holidays: readonly string[],
    vacationRanges: ReadonlyArray<{ startDate: string; endDate: string }>
): boolean {
    return birthdayDayOffIssue(targetIso, holidays, vacationRanges) === null;
}

const WEEKDAYS = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];

export function formatBirthdayLong(isoDate: string): string {
    const [year, month, day] = isoDate.split('-').map(Number);
    const weekday = WEEKDAYS[new Date(Date.UTC(year, month - 1, day)).getUTCDay()];
    return `${weekday}, ${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}`;
}
